const ValidationUtils = {
  validateParams: (...args) => {
    try {
      args.forEach((arg) => {
        if (!arg) {
          throw new Error();
        }
      });
      return true;
    } catch (e) {
      return false;
    }
  },

  // should this check if the value is even a string?
  isEmptyStr: (str) => !str || str.trim().length === 0,

  isDefined: (val) => val !== null && val !== undefined,
};

export default Object.freeze(ValidationUtils);
